import React, { useEffect, useState } from "react";
import PageLayout from "../components/PageLayout";
import { api } from "../lib/api";
import { Link } from "react-router-dom";
import { Gavel, ArrowRight } from "@phosphor-icons/react";

export default function OpenJobs() {
  const [jobs, setJobs] = useState(null);

  useEffect(() => {
    api.get("/jobs?scope=open").then(({ data }) => setJobs(data));
  }, []);

  return (
    <PageLayout>
      <div className="max-w-6xl">
        <div className="kicker">Appraiser</div>
        <h1 className="display-serif text-4xl sm:text-5xl mt-2">Open jobs.</h1>
        <p className="text-zinc-600 mt-2">Pick a job and place your bid.</p>

        <div className="mt-8 grid gap-4 lg:grid-cols-2">
          {jobs === null ? <div className="text-zinc-500">Loading…</div> : jobs.length === 0 ? (
            <div className="surface-card p-8 text-zinc-600">No open jobs right now.</div>
          ) : jobs.map(j => (
            <Link key={j.job_id} to={`/jobs/${j.job_id}`} data-testid={`open-job-card-${j.job_id}`}
              className="surface-card p-6 hover:-translate-y-0.5 transition-transform duration-200 flex items-start gap-4">
              <span className="inline-flex h-11 w-11 items-center justify-center rounded-xl bg-[#CCFBF1] text-[#115E59]">
                <Gavel size={20} weight="duotone" />
              </span>
              <div className="flex-1">
                <div className="font-medium">{j.address}, {j.city} {j.state}</div>
                <div className="text-sm text-zinc-600 mt-1">
                  {j.form_type.replace("_", " ")} • {j.house_sqft || "?"} sqft • {j.travel_distance_mi || 0} mi
                </div>
                <div className="mt-3 flex items-center gap-2">
                  <span className="chip bg-[#FFEDD5] text-[#9A3412]">Min ${j.ai_minimum_fee?.toFixed(0)}</span>
                  <span className="chip bg-emerald-100 text-emerald-900">{j.job_type}</span>
                </div>
              </div>
              <ArrowRight size={18} className="text-zinc-400" />
            </Link>
          ))}
        </div>
      </div>
    </PageLayout>
  );
}
